(function () {
  "use strict";

  var QUERY = {
    goal: {
      treadmill: "banda de alergare",
      bike: "bicicleta fitness",
      strength: "gantere banca de exercitii sau aparat multifunctional pentru forta",
      full_home_gym: "aparat multifunctional pentru home gym complet",
      guidance: "echipament fitness pentru antrenament acasa",
    },
    space: {
      very_small: "compact pliabil pentru apartament cu spatiu redus",
      medium: "pentru o camera obisnuita",
      dedicated: "pentru spatiu de antrenament dedicat",
    },
    usage: {
      light: "pentru incepatori si miscare usoara",
      regular: "pentru antrenament regulat de 3 sau 4 ori pe saptamana",
      intense: "robust pentru antrenament intens aproape zilnic",
    },
    weight: {
      up_to_100: "greutate utilizator suportata de cel putin 100 kg",
      up_to_120: "greutate utilizator suportata de cel putin 120 kg",
      up_to_140: "greutate utilizator suportata de cel putin 140 kg",
      over_140: "greutate utilizator suportata peste 140 kg",
      skip: "",
    },
  };

  var MIN_CAPACITY = {
    up_to_100: 100,
    up_to_120: 120,
    up_to_140: 140,
    over_140: 141,
    skip: 0,
  };

  var BUDGET = {
    under_1000: { min: null, max: 100000, label: "sub 1.000 lei" },
    "1000_2000": { min: 100000, max: 200000, label: "1.000–2.000 lei" },
    "2000_3000": { min: 200000, max: 300000, label: "2.000–3.000 lei" },
    over_3000: { min: 300000, max: null, label: "peste 3.000 lei" },
    flexible: { min: null, max: null, label: "buget flexibil" },
  };

  var GOAL_MATCH = {
    treadmill: ["banda de alerg", "benzi de alerg"],
    bike: ["bicicleta fitness", "biciclete fitness", "minibicicleta"],
    strength: ["ganter", "kettlebell", "haltera", "banca de exerc", "aparat multifunctional"],
    full_home_gym: ["aparat multifunctional", "home gym", "statie fitness"],
    guidance: [],
  };

  function normalize(value) {
    return String(value || "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase();
  }

  function stripHtml(html) {
    var doc = new DOMParser().parseFromString(String(html || ""), "text/html");
    return doc.body.textContent || "";
  }

  function cleanExtra(value) {
    return String(value || "")
      .replace(/[\u0000-\u001f\u007f]/g, " ")
      .replace(/\s+/g, " ")
      .trim()
      .slice(0, 120);
  }

  function amount(value) {
    if (!value || typeof value.amount !== "number") return null;
    return value.amount;
  }

  function money(minor, currency) {
    return new Intl.NumberFormat("ro-RO", {
      style: "currency",
      currency: currency || "RON",
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }).format(Number(minor || 0) / 100);
  }

  function productText(product) {
    var collections = (product.collections || [])
      .map(function (collection) {
        return collection.title || collection.handle || "";
      })
      .join(" ");
    return normalize(
      [product.title, stripHtml(product.description && product.description.html), (product.tags || []).join(" "), collections].join(" "),
    );
  }

  function getCapacity(text) {
    var patterns = [
      /greutate\s+(?:maxima\s+)?(?:a\s+utilizatorului\s+)?(?:admisa|suportata)[^0-9]{0,35}(\d{2,3})\s*kg/g,
      /suporta(?:nd)?\s+(?:o\s+greutate\s+(?:a\s+utilizatorului\s+)?(?:de\s+)?(?:pana\s+la\s+)?|utilizatori\s+(?:de\s+)?(?:pana\s+la\s+)?)(\d{2,3})\s*kg/g,
      /greutatea\s+utilizatorului[^0-9]{0,35}(\d{2,3})\s*kg/g,
    ];
    var values = [];
    patterns.forEach(function (pattern) {
      var match;
      while ((match = pattern.exec(text))) values.push(Number(match[1]));
    });
    return values.length ? Math.max.apply(Math, values) : null;
  }

  function needsCapacity(product) {
    return /banda|bicicleta|stepper|banca|aparat\s+multifunctional|statie\s+fitness/.test(
      normalize(product.title),
    );
  }

  function isCompact(text) {
    return /pliabil|pliere|compact|spatiu redus|sub pat|dimensiuni reduse/.test(text);
  }

  function availableVariant(product) {
    return (product.variants || []).find(function (variant) {
      return variant.availability && variant.availability.available;
    });
  }

  function matchesGoal(product, goal, text) {
    var needles = GOAL_MATCH[goal] || [];
    if (!needles.length) return true;
    return needles.some(function (needle) {
      return text.indexOf(needle) !== -1;
    });
  }

  function assessProduct(product, answers) {
    var text = productText(product);
    var variant = availableVariant(product);
    var price = amount(product.price_range && product.price_range.min);
    var budget = BUDGET[answers.budget] || BUDGET.flexible;
    var minCapacity = MIN_CAPACITY[answers.weight] || 0;
    var capacity = getCapacity(text);
    var capacityRelevant = needsCapacity(product);
    var compact = isCompact(text);

    if (!variant || price === null) return null;
    if (text.indexOf("resigilat") !== -1 && normalize(answers.extra).indexOf("resigilat") === -1) return null;
    if (budget.min !== null && price < budget.min) return null;
    if (budget.max !== null && price > budget.max) return null;
    if (!matchesGoal(product, answers.goal, text)) return null;
    if (answers.space === "very_small" && !compact) return null;
    if (minCapacity && capacityRelevant && (!capacity || capacity < minCapacity)) return null;

    var score = 10;
    var reasons = [];

    reasons.push("Preț actual în bugetul ales: " + money(price, product.price_range.min.currency));

    if (answers.space === "very_small" && compact) {
      reasons.push(text.indexOf("pliabil") !== -1 ? "Descrierea confirmă că este pliabil" : "Descrierea confirmă formatul compact");
      score += 4;
    }

    if (minCapacity && capacityRelevant && capacity) {
      reasons.push("Descrierea indică suport de până la " + capacity + " kg");
      score += 4;
    }

    if (answers.usage === "intense" && /robust|intens|profesional|motor\s+(?:de\s+)?[2-9]/.test(text)) {
      reasons.push("Descrierea evidențiază o construcție pentru utilizare solicitantă");
      score += 2;
    } else if (answers.usage === "light" && /incepator|miscare usoara|mers|recuperare|compact/.test(text)) {
      reasons.push("Descrierea îl poziționează pentru mișcare ușoară sau început de rutină");
      score += 2;
    }

    if (reasons.length < 3) reasons.push("Este disponibil acum în catalogul eFitness");

    return {
      product: product,
      variant: variant,
      price: price,
      score: score,
      reasons: reasons.slice(0, 3),
    };
  }

  function element(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }

  function appendHidden(form, name, value) {
    var input = document.createElement("input");
    input.type = "hidden";
    input.name = name;
    input.value = value;
    form.appendChild(input);
  }

  function track(eventName, properties) {
    var payload = Object.assign({ event: eventName, feature_name: "citera_assist" }, properties || {});
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);

    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === "function") {
      var shopifyEventName = eventName.replace(/^citera_assist_/, "citera_assist:");
      try {
        var publication = window.Shopify.analytics.publish(shopifyEventName, payload);
        if (publication && typeof publication.catch === "function") publication.catch(function () {});
      } catch (error) {}
    }

    document.dispatchEvent(new CustomEvent("citera:assist", { detail: payload }));
  }

  function secureProfileUrl(value) {
    var profile = String(value || "").trim();
    if (profile.indexOf("//") === 0) profile = "https:" + profile;
    try {
      profile = new URL(profile, window.location.href).href;
    } catch (error) {
      return "";
    }
    return profile.indexOf("https://") === 0 ? profile : "";
  }

  function markCartAssisted(sessionId) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    return fetch(root + "cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({
        attributes: {
          "Citera Assist": "Da",
          "Citera Assist sesiune": sessionId,
        },
      }),
      keepalive: true,
    }).catch(function () {});
  }

  function init(root) {
    if (root.dataset.assistReady === "true") return;
    root.dataset.assistReady = "true";

    var dialog = root.querySelector("[data-assist-dialog]");
    var form = root.querySelector("[data-assist-form]");
    var steps = Array.prototype.slice.call(root.querySelectorAll("[data-assist-step]"));
    var openButton = root.querySelector("[data-assist-open]");
    var closeButton = root.querySelector("[data-assist-close]");
    var backButton = root.querySelector("[data-assist-back]");
    var nextButton = root.querySelector("[data-assist-next]");
    var submitButton = root.querySelector("[data-assist-submit]");
    var progressWrap = root.querySelector("[data-assist-progress-wrap]");
    var progress = root.querySelector("[data-assist-progress]");
    var progressLabel = root.querySelector("[data-assist-progress-label]");
    var progressName = root.querySelector("[data-assist-progress-name]");
    var loading = root.querySelector("[data-assist-loading]");
    var results = root.querySelector("[data-assist-results]");
    var resultGrid = root.querySelector("[data-assist-result-grid]");
    var resultsTitle = root.querySelector("[data-assist-results-title]");
    var empty = root.querySelector("[data-assist-empty]");
    var emptyCopy = root.querySelector("[data-assist-empty-copy]");
    var standardSearch = root.querySelector("[data-assist-search-link]");
    var panel = root.querySelector(".citera-assist__panel");
    var currentStep = 0;
    var sessionId = "ca_" + Date.now().toString(36) + "_" + Math.random().toString(36).slice(2, 8);
    var lastInvoker = null;

    if (!dialog || !form || !steps.length) return;

    function selectedOnStep(index) {
      return Boolean(steps[index].querySelector("input[type='radio']:checked"));
    }

    function updateStep() {
      steps.forEach(function (step, index) {
        step.hidden = index !== currentStep;
      });
      progress.value = currentStep + 1;
      progress.textContent = currentStep + 1 + " din " + steps.length;
      progress.setAttribute("aria-valuetext", "Pasul " + (currentStep + 1) + " din " + steps.length);
      progressLabel.textContent = "Pasul " + (currentStep + 1) + " din " + steps.length;
      progressName.textContent = steps[currentStep].getAttribute("data-step-name") || "";
      backButton.hidden = currentStep === 0;
      nextButton.hidden = currentStep === steps.length - 1;
      submitButton.hidden = currentStep !== steps.length - 1;
      nextButton.disabled = !selectedOnStep(currentStep);
      submitButton.disabled = !selectedOnStep(currentStep);
      var legend = steps[currentStep].querySelector("legend");
      if (legend) legend.focus && legend.focus();
    }

    function openDialog() {
      lastInvoker = document.activeElement;
      var preselectedGoal = openButton.getAttribute("data-assist-goal") || "";
      var preselectedInput = preselectedGoal
        ? form.querySelector('input[name="goal"][value="' + preselectedGoal + '"]')
        : null;
      if (preselectedInput) {
        form.querySelectorAll('input[name="goal"]').forEach(function (input) {
          input.checked = input === preselectedInput;
        });
        currentStep = 0;
        updateStep();
      }
      try {
        dialog.showModal();
      } catch (error) {
        dialog.setAttribute("open", "");
      }
      document.documentElement.style.overflow = "hidden";
      closeButton.focus();
      var placement = openButton.getAttribute("data-assist-placement") || "homepage_section";
      var sourceProductId = openButton.getAttribute("data-assist-product-id") || undefined;
      var sourceProductHandle = openButton.getAttribute("data-assist-product-handle") || undefined;
      openButton.removeAttribute("data-assist-placement");
      openButton.removeAttribute("data-assist-goal");
      openButton.removeAttribute("data-assist-product-id");
      openButton.removeAttribute("data-assist-product-handle");
      track("citera_assist_opened", {
        assist_session_id: sessionId,
        placement: placement,
        preselected_goal: preselectedGoal || undefined,
        source_product_id: sourceProductId,
        source_product_handle: sourceProductHandle,
      });
    }

    function closeDialog() {
      if (dialog.open && typeof dialog.close === "function") dialog.close();
      else dialog.removeAttribute("open");
      document.documentElement.style.overflow = "";
      if (lastInvoker && typeof lastInvoker.focus === "function") lastInvoker.focus();
    }

    function values() {
      var data = new FormData(form);
      return {
        goal: data.get("goal"),
        space: data.get("space"),
        usage: data.get("usage"),
        weight: data.get("weight"),
        budget: data.get("budget"),
        extra: cleanExtra(data.get("extra")),
      };
    }

    function buildQuery(answers) {
      return [
        QUERY.goal[answers.goal],
        QUERY.space[answers.space],
        QUERY.usage[answers.usage],
        QUERY.weight[answers.weight],
        answers.extra,
      ]
        .filter(Boolean)
        .join(", ");
    }

    function searchUrl(answers) {
      var query = [QUERY.goal[answers.goal], answers.extra].filter(Boolean).join(" ");
      return "/search?q=" + encodeURIComponent(query) + "&type=product";
    }

    function catalogFilters(answers) {
      var budget = BUDGET[answers.budget] || BUDGET.flexible;
      var filters = { available: true };
      if (budget.min !== null || budget.max !== null) {
        filters.price = {};
        if (budget.min !== null) filters.price.min = budget.min;
        if (budget.max !== null) filters.price.max = budget.max;
      }
      return filters;
    }

    function callCatalog(answers) {
      var profile = secureProfileUrl(root.getAttribute("data-profile-url"));
      var endpoint = root.getAttribute("data-endpoint") || "/api/ucp/mcp";
      if (!profile) return Promise.reject(new Error("catalog_profile_missing"));
      return fetch(endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json, text/event-stream",
        },
        body: JSON.stringify({
          jsonrpc: "2.0",
          method: "tools/call",
          id: Date.now(),
          params: {
            name: "search_catalog",
            arguments: {
              meta: { "ucp-agent": { profile: profile } },
              catalog: {
                query: buildQuery(answers),
                context: {
                  address_country: "RO",
                  language: "ro-RO",
                  currency: "RON",
                  intent: "shopping",
                },
                filters: catalogFilters(answers),
                pagination: { limit: 12 },
              },
            },
          },
        }),
      }).then(function (response) {
        if (!response.ok) throw new Error("catalog_http_" + response.status);
        return response.json();
      }).then(function (data) {
        if (data.error) throw new Error("catalog_rpc_error");
        var result = data.result || {};
        if (result.isError) throw new Error("catalog_tool_error");
        var products = result.structuredContent && result.structuredContent.products;
        if (!Array.isArray(products)) throw new Error("catalog_invalid_response");
        return products;
      });
    }

    function renderResult(item, index) {
      var product = item.product;
      var card = element("article", "citera-assist__result-card");
      var media = element("div", "citera-assist__result-media");
      var rank = element("span", "citera-assist__result-rank", "#" + (index + 1));
      var imageData = (product.media || [])[0] || (item.variant.media || [])[0];
      if (imageData && imageData.url) {
        var image = document.createElement("img");
        image.src = imageData.url;
        image.alt = product.title || "Produs eFitness";
        image.loading = "lazy";
        image.decoding = "async";
        media.appendChild(image);
      }
      media.appendChild(rank);

      var body = element("div", "citera-assist__result-body");
      body.appendChild(element("h4", "", product.title));

      var price = element("p", "citera-assist__price");
      var currency = (product.price_range && product.price_range.min && product.price_range.min.currency) || "RON";
      price.appendChild(document.createTextNode(money(item.price, currency)));
      var listPrice = amount(product.list_price_range && product.list_price_range.min);
      if (listPrice && listPrice > item.price) price.appendChild(element("s", "", money(listPrice, currency)));
      body.appendChild(price);

      var reasons = element("ul", "citera-assist__reasons");
      item.reasons.forEach(function (reason) {
        reasons.appendChild(element("li", "", reason));
      });
      body.appendChild(reasons);

      var actions = element("div", "citera-assist__result-actions");
      var addForm = document.createElement("form");
      var shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
      addForm.method = "post";
      addForm.action = shopRoot + "cart/add";
      addForm.setAttribute("data-cart-form", "");
      addForm.setAttribute("data-assist-add", "");
      addForm.setAttribute("data-product-id", product.id || "");
      addForm.setAttribute("data-product-name", product.title || "");
      addForm.setAttribute("data-position", String(index + 1));
      addForm.setAttribute("data-value", String(item.price));
      addForm.setAttribute("data-currency", currency);
      appendHidden(addForm, "id", String(item.variant.id || "").split("/").pop());
      appendHidden(addForm, "quantity", "1");
      appendHidden(addForm, "properties[_Citera Assist]", "Recomandare");
      appendHidden(addForm, "properties[_Citera Assist sesiune]", sessionId);
      var addButton = element("button", "button", "Adaugă în coș");
      addButton.type = "submit";
      addForm.appendChild(addButton);
      actions.appendChild(addForm);

      var productLink = element("a", "button button--secondary citera-assist__product-link", "Vezi produsul");
      productLink.href = product.url;
      productLink.setAttribute("data-assist-product-link", "");
      productLink.setAttribute("data-product-id", product.id || "");
      productLink.setAttribute("data-product-name", product.title || "");
      productLink.setAttribute("data-position", String(index + 1));
      actions.appendChild(productLink);
      body.appendChild(actions);

      card.appendChild(media);
      card.appendChild(body);
      return card;
    }

    function showResults(items, answers, rawCount) {
      form.hidden = true;
      progressWrap.hidden = true;
      loading.hidden = true;
      empty.hidden = true;
      results.hidden = false;
      if (panel) panel.scrollTop = 0;
      resultGrid.replaceChildren();
      resultsTitle.textContent = items.length === 1 ? "Am găsit o potrivire clară" : "Am găsit " + items.length + " opțiuni potrivite";
      items.forEach(function (item, index) {
        resultGrid.appendChild(renderResult(item, index));
      });
      track("citera_assist_search_completed", {
        assist_session_id: sessionId,
        result_count: items.length,
        catalog_result_count: rawCount,
        search_source: "shopify_storefront_catalog_ucp",
        goal: answers.goal,
        budget: answers.budget,
      });
    }

    function showEmpty(answers, reason) {
      form.hidden = true;
      progressWrap.hidden = true;
      loading.hidden = true;
      results.hidden = true;
      empty.hidden = false;
      if (panel) panel.scrollTop = 0;
      standardSearch.href = searchUrl(answers);
      if (reason === "catalog_error") {
        emptyCopy.textContent = "Catalogul inteligent nu a răspuns acum. Poți încerca din nou, folosi căutarea standard sau discuta cu un consultant.";
      } else {
        emptyCopy.textContent = "Niciun produs nu confirmă toate condițiile selectate. Nu vrem să-ți recomandăm ceva nepotrivit.";
      }
      track(reason === "catalog_error" ? "citera_assist_error" : "citera_assist_no_results", {
        assist_session_id: sessionId,
        error_type: reason === "catalog_error" ? "catalog_unavailable" : undefined,
        goal: answers.goal,
        budget: answers.budget,
      });
    }

    function resetToAnswers() {
      results.hidden = true;
      empty.hidden = true;
      loading.hidden = true;
      form.hidden = false;
      progressWrap.hidden = false;
      currentStep = 0;
      if (panel) panel.scrollTop = 0;
      updateStep();
      track("citera_assist_answers_reopened", { assist_session_id: sessionId });
    }

    openButton.addEventListener("click", openDialog);
    closeButton.addEventListener("click", closeDialog);
    dialog.addEventListener("close", function () {
      document.documentElement.style.overflow = "";
    });
    dialog.addEventListener("click", function (event) {
      if (event.target === dialog) closeDialog();
    });

    form.addEventListener("change", function () {
      nextButton.disabled = !selectedOnStep(currentStep);
      submitButton.disabled = !selectedOnStep(currentStep);
    });

    nextButton.addEventListener("click", function () {
      if (!selectedOnStep(currentStep)) return;
      var field = steps[currentStep].querySelector("input[type='radio']:checked");
      track("citera_assist_step_completed", {
        assist_session_id: sessionId,
        step_number: currentStep + 1,
        step_name: steps[currentStep].getAttribute("data-step-name"),
        selected_option: field && field.value,
      });
      currentStep = Math.min(currentStep + 1, steps.length - 1);
      updateStep();
    });

    backButton.addEventListener("click", function () {
      currentStep = Math.max(0, currentStep - 1);
      updateStep();
    });

    form.addEventListener("submit", function (event) {
      event.preventDefault();
      if (!selectedOnStep(currentStep)) return;
      var answers = values();
      var field = steps[currentStep].querySelector("input[type='radio']:checked");
      track("citera_assist_step_completed", {
        assist_session_id: sessionId,
        step_number: currentStep + 1,
        step_name: steps[currentStep].getAttribute("data-step-name"),
        selected_option: field && field.value,
      });
      form.hidden = true;
      progressWrap.hidden = true;
      loading.hidden = false;
      results.hidden = true;
      empty.hidden = true;
      track("citera_assist_search_started", {
        assist_session_id: sessionId,
        goal: answers.goal,
        space: answers.space,
        usage: answers.usage,
        weight_band: answers.weight,
        budget: answers.budget,
        has_extra_condition: Boolean(answers.extra),
      });
      callCatalog(answers)
        .then(function (products) {
          var items = products
            .map(function (product) {
              return assessProduct(product, answers);
            })
            .filter(Boolean)
            .sort(function (a, b) {
              return b.score - a.score || a.price - b.price;
            });
          var max = Math.max(1, Math.min(3, Number(root.getAttribute("data-max-results")) || 3));
          if (!items.length) showEmpty(answers, "no_exact_match");
          else showResults(items.slice(0, max), answers, products.length);
        })
        .catch(function () {
          showEmpty(answers, "catalog_error");
        });
    });

    root.addEventListener("click", function (event) {
      var restart = event.target.closest("[data-assist-restart]");
      if (restart) {
        resetToAnswers();
        return;
      }
      var contact = event.target.closest("[data-assist-contact]");
      if (contact) {
        track("citera_assist_contact_clicked", { assist_session_id: sessionId });
        return;
      }
      var link = event.target.closest("[data-assist-product-link]");
      if (link) {
        markCartAssisted(sessionId);
        track("citera_assist_recommendation_clicked", {
          assist_session_id: sessionId,
          product_id: link.getAttribute("data-product-id"),
          product_name: link.getAttribute("data-product-name"),
          position: Number(link.getAttribute("data-position")),
          destination: "product_page",
        });
      }
    });

    root.addEventListener("submit", function (event) {
      var addForm = event.target.closest("[data-assist-add]");
      if (!addForm) return;
      markCartAssisted(sessionId);
      track("citera_assist_add_to_cart", {
        assist_session_id: sessionId,
        product_id: addForm.getAttribute("data-product-id"),
        product_name: addForm.getAttribute("data-product-name"),
        position: Number(addForm.getAttribute("data-position")),
        value: Number(addForm.getAttribute("data-value")) / 100,
        currency: addForm.getAttribute("data-currency") || "RON",
      });
    });

    updateStep();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll("[data-citera-assist]").forEach(init);
  }

  document.addEventListener("click", function (event) {
    var externalTrigger = event.target.closest("[data-assist-external-open]");
    if (!externalTrigger) return;
    var internalTrigger = document.querySelector("[data-citera-assist] [data-assist-open]");
    if (!internalTrigger) return;
    event.preventDefault();
    internalTrigger.setAttribute(
      "data-assist-placement",
      externalTrigger.getAttribute("data-assist-placement") || "homepage_hero",
    );
    ["data-assist-goal", "data-assist-product-id", "data-assist-product-handle"].forEach(function (attribute) {
      var value = externalTrigger.getAttribute(attribute);
      if (value) internalTrigger.setAttribute(attribute, value);
      else internalTrigger.removeAttribute(attribute);
    });
    internalTrigger.click();
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });
})();
